export enum Status {
    bad = 'bad',
    fine = 'fine',
    good = 'good',
    disruption = 'disruption',
    out = 'out',
    inaccurate = 'inaccurate',
    noValue = 'noValue',
}
